import { Injectable } from '@angular/core';
import { AppAuthClaims } from '@dataclouder/app-auth';
import { HttpCoreService } from '@dataclouder/ngx-core';

@Injectable({
  providedIn: 'root',
})
export class UserBaseService {
  constructor(private httpService: HttpCoreService) {}

  getUserSnapshot() {
    // return this.httpService.get<IUser>('/user-snapshot');
    return { email: 'test' };
  }

  updateUserClaimsAndRefresh(claims: AppAuthClaims) {
    return this.httpService.post('/update-user-claims', claims);
  }
}
